module.exports = __webpack_public_path__ + "assets/pictograms/generic_user.6d150b77945a33e14cffaf4ec417e5af.svg";